export default __webpack_public_path__ + "static/media/hero_caracal_four.3bb5e0e6.jpg";